/* El panel de bienvenida — Cuadros Splash

   Cuándo aparece (lo que pase antes de los tres):
     · a los N segundos (ajustable en el editor, 25 por defecto),
     · al llegar a la mitad de la página,
     · al ir a cerrar la pestaña (el ratón sale por arriba).

   Cuándo NO aparece nunca:
     · en la cesta ni en el pago — ahí interrumpir es tirar una venta,
     · si ya se cerró (30 días de tregua),
     · si esa persona ya se suscribió (para siempre),
     · si el chat de Ebora está abierto: dos cosas hablándole a la vez es
       una de más.

   El alta va por dos vías a la vez y ninguna depende de la otra:
     1. Al formulario de clientes de Shopify (crea el cliente con
        consentimiento de marketing, que es el registro que manda),
     2. Al backend de Ebora, que lo pasa a Brevo y dispara el correo de
        bienvenida. Si esa parte no está configurada o falla, el alta de
        Shopify se ha hecho igual y el cliente ve su código.
*/

(function () {
  var raiz = document.getElementById('cs-popup');
  if (!raiz) return;

  var CLAVE_CERRADO = 'cs_popup_cerrado_hasta';
  var CLAVE_SUSCRITO = 'cs_popup_suscrito';
  var DIAS_DE_TREGUA = 30;

  var panel = raiz.querySelector('.cs-popup__panel');
  var formulario = raiz.querySelector('form.cs-popup__form');
  var campo = raiz.querySelector('#cs-popup-correo');
  if (!formulario || !campo) return;
  var boton = formulario.querySelector('.cs-popup__enviar');
  var aviso = raiz.querySelector('[data-cs-popup-aviso]');
  var vivo = raiz.querySelector('[data-cs-popup-form]');
  var gracias = raiz.querySelector('[data-cs-popup-gracias]');

  var textos = {};
  try {
    textos = JSON.parse(document.querySelector('[data-cs-popup-textos]').textContent);
  } catch (e) {
    textos = {};
  }

  var abierto = false;
  var focoPrevio = null;

  /* ---------- Memoria ---------- */

  function leer(clave) {
    try {
      return window.localStorage.getItem(clave);
    } catch (e) {
      return null;
    }
  }

  function guardar(clave, valor) {
    try {
      window.localStorage.setItem(clave, valor);
    } catch (e) {
      /* navegación privada: se comporta como si no hubiera memoria */
    }
  }

  function tieneVetado() {
    if (leer(CLAVE_SUSCRITO) === '1') return true;
    var hasta = parseInt(leer(CLAVE_CERRADO) || '0', 10);
    return hasta > Date.now();
  }

  /* ---------- Dónde no molestar ---------- */

  function esPaginaDelicada() {
    var ruta = window.location.pathname;
    if (/\/(cart|checkouts?|challenge|account)(\/|$)/.test(ruta)) return true;
    /* La página del probador («Cuélgalo en tu casa») ofrece su propio 10%
       en la ventana «¿Te la mandamos por correo?»: dos avisos con el mismo
       10% a la vez es uno de más. En la ficha el probador lleva
       data-pagina (solo enseña la portada), así que allí sí sale este. */
    return !!document.querySelector('[data-cs-salon]:not([data-pagina])');
  }

  /* ---------- Abrir y cerrar ---------- */

  /* Con el aviso de cookies de Shopify a la vista, la ventana espera a que
     se conteste: en el móvil se montaban las dos y no se veía la tienda
     (1 nov 2026). En cuanto el aviso se va, se vuelve a intentar. */
  var reintento = null;
  function avisoCookiesVisible() {
    var aviso = document.getElementById('shopify-pc__banner');
    return !!(aviso && aviso.offsetHeight > 0);
  }

  function abrir() {
    if (abierto || tieneVetado()) return;
    if (avisoCookiesVisible()) {
      if (!reintento) {
        reintento = window.setInterval(function () {
          if (avisoCookiesVisible()) return;
          window.clearInterval(reintento);
          reintento = null;
          window.setTimeout(abrir, 6000);
        }, 1000);
      }
      return;
    }
    /* Si el asesor está abierto, esperamos: dos cosas hablando a la vez
       es una de más. Se volverá a intentar en el siguiente disparador. */
    var asesor = document.getElementById('cs-asesor-panel');
    if (asesor && !asesor.hidden) return;

    abierto = true;
    focoPrevio = document.activeElement;
    raiz.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    window.setTimeout(function () {
      campo.focus();
    }, 260);
  }

  function cerrar(recordar) {
    if (!abierto) return;
    abierto = false;
    raiz.hidden = true;
    document.documentElement.style.overflow = '';
    if (recordar) {
      guardar(CLAVE_CERRADO, String(Date.now() + DIAS_DE_TREGUA * 86400000));
    }
    if (focoPrevio && focoPrevio.focus) focoPrevio.focus();
  }

  raiz.querySelectorAll('[data-cs-popup-cerrar]').forEach(function (b) {
    b.addEventListener('click', function () {
      cerrar(true);
    });
  });

  var velo = raiz.querySelector('[data-cs-popup-fuera]');
  if (velo) {
    velo.addEventListener('click', function () {
      cerrar(true);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && abierto) cerrar(true);
  });

  /* Tab dando vueltas dentro del panel mientras está abierto. */
  panel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focables = panel.querySelectorAll('button, a[href], input:not([type=hidden])');
    var visibles = Array.prototype.filter.call(focables, function (f) {
      return f.offsetParent !== null;
    });
    if (!visibles.length) return;
    var primero = visibles[0];
    var ultimo = visibles[visibles.length - 1];
    if (e.shiftKey && document.activeElement === primero) {
      e.preventDefault();
      ultimo.focus();
    } else if (!e.shiftKey && document.activeElement === ultimo) {
      e.preventDefault();
      primero.focus();
    }
  });

  /* ---------- El alta ---------- */

  function pintarAviso(mensaje) {
    aviso.textContent = mensaje;
    aviso.hidden = !mensaje;
  }

  function correoValido(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  /* A Brevo, por el backend de Ebora, JUSTO ANTES de que la página
     navegue. Se usa sendBeacon precisamente por eso: es el único envío
     que el navegador garantiza aunque la página se esté yendo. Un fetch
     normal se cancelaría a medias.

     Si no hay URL de asesor configurada, esta vía no existe y el alta de
     Shopify se hace igual: el cliente queda suscrito en la tienda. */
  function avisarABrevo(correo) {
    var base = (raiz.dataset.asesor || '').replace(/\/+$/, '');
    if (!base || !navigator.sendBeacon) return;
    try {
      navigator.sendBeacon(
        base + '/newsletter',
        new Blob([JSON.stringify({ correo: correo, origen: 'popup' })], {
          type: 'application/json',
        })
      );
    } catch (e) {
      /* sin beacon, el alta de Shopify sigue su curso igualmente */
    }
  }

  /* Se deja pasar el envío nativo: es lo único que lleva el token del
     CAPTCHA de Shopify. Aquí solo se valida el correo antes de gastar una
     navegación, y se avisa a Brevo de camino. */
  formulario.addEventListener('submit', function (e) {
    var correo = campo.value.trim();

    if (!correoValido(correo)) {
      e.preventDefault();
      campo.setAttribute('aria-invalid', 'true');
      pintarAviso(textos.correoMal || '');
      campo.focus();
      return;
    }

    campo.removeAttribute('aria-invalid');
    pintarAviso('');
    boton.disabled = true;
    boton.textContent = textos.enviando || '…';

    guardar(CLAVE_SUSCRITO, '1');
    avisarABrevo(correo);
    /* sin preventDefault: el formulario sigue su camino */
  });

  /* ---------- Copiar el código ---------- */

  var copiar = raiz.querySelector('[data-cs-popup-copiar]');
  if (copiar) {
    copiar.addEventListener('click', function () {
      var codigo = raiz.querySelector('[data-cs-popup-codigo]').textContent.trim();
      var listo = function () {
        copiar.textContent = textos.copiado || '✓';
        window.setTimeout(function () {
          copiar.textContent = textos.copiar || 'Copiar';
        }, 2200);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(codigo).then(listo, function () {
          /* Sin permiso para el portapapeles: el código está a la vista y
             se puede seleccionar a mano, así que no se avisa de nada. */
        });
      }
    });
  }

  /* ---------- Al volver de suscribirse ---------- */

  /* Shopify devuelve a la página con el ancla del formulario. Ojo a la
     trampa 22: `form.posted_successfully?` es cierto en TODOS los
     formularios de cliente de la página, no solo en el que se envió, así
     que hay que mirar además el hash para saber que fue ESTE panel y no
     el alta del pie. */
  if (raiz.hasAttribute('data-recien-suscrito') && window.location.hash === '#PopupBienvenida') {
    guardar(CLAVE_SUSCRITO, '1');
    vivo.hidden = true;
    gracias.hidden = false;
    abierto = true;
    raiz.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    return; /* nada de disparadores: ya está abierto y en modo gracias */
  }

  /* ---------- Los disparadores ---------- */

  if (tieneVetado() || esPaginaDelicada()) return;

  var espera = parseInt(raiz.dataset.espera || '25', 10);
  window.setTimeout(abrir, Math.max(5, espera) * 1000);

  /* A media página: quien ha bajado hasta ahí está mirando de verdad. */
  var alBajar = function () {
    var alto = document.documentElement.scrollHeight - window.innerHeight;
    if (alto > 0 && window.scrollY / alto > 0.5) {
      window.removeEventListener('scroll', alBajar);
      abrir();
    }
  };
  window.addEventListener('scroll', alBajar, { passive: true });

  /* Al ir a cerrar la pestaña. Solo con ratón: en móvil no existe ese
     gesto y saltaría sin motivo. */
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) abrir();
    });
  }
})();
